import React from 'react';

interface ViewCardContextType {
	isCardOpened: boolean;
}

export const ViewCardContext = React.createContext<ViewCardContextType>({
	isCardOpened: false,
});

